import React, { useEffect, useState } from "react";
import CreatableSelect from "react-select/creatable";
import { customReactSelectStyles } from "./medication-select";
import { reasonOptions } from "../../service-steps/clinical-assessment/data";

const PRNSelect = ({
  onChange = () => {},
  selectedMedicine = {
    doseOptions: [],
    dose: null,
    formOptions: [],
    prnDetail: null,
    routeOptions: [],
    route: null,
  },
  isRequired = false, // Add the new prop here
  error = false,
  value: actualValue = { value: "", label: "" },
  isDisabled= false
}) => {


  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState(reasonOptions);
  const [value, setValue] = useState(null);
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    const { prnDetail } = selectedMedicine;
    if (prnDetail) {
      const prnOption = {
        label: prnDetail.replace(/[\(\)]/g, ""),
        value: prnDetail.toLowerCase().replace(/[\(\)]/g, ""),
      };
      setValue(prnOption);
      onChange(prnOption);
      setOptions([...reasonOptions, prnOption]);
    } else {
      setValue(null);
    }
  }, [selectedMedicine]);

  const handleCreate = (inputValue) => {
    setIsLoading(true);
    setTimeout(() => {
      const newOption = {
        label: inputValue,
        value: inputValue ,
      };
      setIsLoading(false);
      setOptions((prevOptions) => [...prevOptions, newOption]);
      setValue(newOption);
      setShowError(isRequired && !newOption); // Show error if required and no new option
      onChange(newOption);
    }, 300);
  };

  const handleBlur = () => {
    if (isRequired && !value) {
      setShowError(true);
    } else {
      setShowError(false);
    }
  };

  useEffect(() => {
    if (actualValue?.value) {
      setValue(actualValue);
    } else {
      setValue(null);
    }
  }, [actualValue]);

  useEffect(() => {
    if (error) {
      setShowError(true);
    } else {
      setShowError(false);
    }
  }, [error]);

  return (
    <div className="w-full col-span-8">
      <div
        className={`relative rounded-[4px] border-[1px] ${isDisabled && "opacity-40"} ${
          !isDisabled && showError ? "border-red-200" : "border-gray-100"
        } ${!isDisabled && isRequired && value === null ? "bg-blue-100" : "bg-white"} px-3 py-3 focus-within:border-REELBlue focus-within:border-[2px]`}
      >
        <div className="">
          <span className="block mb-1 text-gray-900 text-body-xs">
            PRN Reason {isRequired && <span className="">*</span>}
          </span>
          <CreatableSelect
            isClearable
            styles={customReactSelectStyles(isRequired, value)}
            isDisabled={isLoading || isDisabled}
            isLoading={isLoading}
            onChange={(newValue) => {
              setValue(newValue);
              setShowError(isRequired && !newValue);
              onChange(newValue);
            }}
            onCreateOption={handleCreate}
            onBlur={handleBlur}
            options={options}
            value={value}
            placeholder="Select PRN reason"
            className="col-span-4"
          />
          {!isDisabled && showError && (
            <span className="block mt-1 text-red-200 text-body-xs">
              PRN reason is required
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default PRNSelect;